import type { FunctionComponent } from 'react';

import type { IPaymentMethod, MethodType } from '@endeavour/payment-integration';

import { ContextLink } from '../../../shared/components/context-link/context-link';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { useDesktop } from '../../../shared/hooks/breakpoint';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';
import { getAssetUrl } from '../../../shared/utils/get-asset-url';

import styles from './payment-method-switcher.module.scss';

const style = createStyleHelper(styles, 'payment-method-switcher');

export interface IPaymentMethodSwitcherProps {
    className?: string;
    paymentMethod: IPaymentMethod;
    methodType: MethodType;
}

export const PaymentMethodSwitcher: FunctionComponent<IPaymentMethodSwitcherProps> = ({
    className,
    paymentMethod,
    methodType,
}) => {
    const isDesktop = useDesktop();
    const imageUrl = getAssetUrl(paymentMethod.image);

    if (!isDesktop) {
        return null;
    }

    return (
        <ContextLink
            className={createClassName([style(), className])}
            to={`/cashier/${methodType.toLocaleLowerCase()}/`}
        >
            <div className={style('payment-method')}>
                <div className={style('icon-section')}>
                    {imageUrl ? <img className={style('icon-image')} src={imageUrl} /> : null}
                </div>
                <div className={style('change-method-text')}>
                    <FormattedMessage
                        id="cashier.select-method.change-payment-method"
                        defaultMessage="Change payment method"
                    />
                </div>
            </div>
        </ContextLink>
    );
};
